import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import { Provider } from "react-redux";
import store, { history } from "./store";
import { ConnectedRouter } from "connected-react-router";

// import "bootstrap/dist/css/bootstrap.css";
import "./assets/vendor/nucleo/css/nucleo.css";
// import "./assets/vendor/@fortawesome/fontawesome-free/css/all.min.css";
import "react-toastify/dist/ReactToastify.css";
// import "./assets/scss/argon-dashboard-react.scss";
import "./assets/css/admin.css";
import { StripeProvider } from "react-stripe-elements";
import AdminLayout from "./layouts/Admin.jsx";
import AuthLayout from "./layouts/Auth.jsx";
import UserLayout from "./layouts/User.jsx";
import PageNotFound from "./views/PageNotFound";
import httpService from "./utils/api.interceptors";
httpService.setupInterceptors(store, history);

ReactDOM.render(
  <StripeProvider apiKey="pk_test_Zph2OoJqykNBKochMj8sZc4G00EUXtk8ic">
    <Provider store={store}>
      <BrowserRouter>
        <ConnectedRouter history={history}>
          <Switch>
            <Route
              path="/dash/admin"
              render={(props) => <AdminLayout {...props} />}
            />
            <Route
              path="/dash/auth"
              render={(props) => <AuthLayout {...props} />}
            />
            <Route
              path="/dash/user"
              render={(props) => <UserLayout {...props} />}
            />
            <Redirect from="/dash/" to="/dash/auth/login" />
            <Route component={PageNotFound} />
          </Switch>
        </ConnectedRouter>
      </BrowserRouter>
    </Provider>
  </StripeProvider>,
  document.getElementById("root")
);

// import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';
// import App from './App';
// import * as serviceWorker from './serviceWorker';

// ReactDOM.render(<App />, document.getElementById('root'));

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
